import './assets/tailwind.css'
import '../node_modules/@fortawesome/fontawesome-free/css/all.css'

import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueGlobalVar from 'vue-global-var'
import Start from './components/Start.vue'
import Welcome from './components/Welcome.vue'
import Gender from './components/Gender.vue'
import Adjust from './components/Adjust.vue'
import Intro from './components/Intro.vue'
import Steps from './components/Steps.vue'
import Headset from './components/Headset.vue'
import Difficulty from './components/Difficulty.vue'
import Record from './components/Record.vue'
import Photo from './components/Photo.vue'
import Preview from './components/Preview.vue'
import Selection from './components/Selection.vue'
import Email from './components/Email.vue'
import vuetify from './plugins/vuetify';
import Goodbye from './components/Goodbye.vue'
import VModal from 'vue-js-modal'

Vue.use(VueRouter)
Vue.use(VueGlobalVar, {
  globals: {
    $variables: {
      videoPath: '',
      gender: 'f',
      difficulty: 'easy',
      recording: null,
      photoBlob: null,
      photoBase64: null
    },
    $settings: {
    }
  },
});
Vue.config.productionTip = false
Vue.use(VModal)

const routes = [
  { path: '/', name: "home", component: Start },
  { path: '/welcome', name: "welcome", component: Welcome },
  { path: '/gender/:lang', name: "gender", component: Gender, props: { lang: String } },
  { path: '/adjust/:lang', name: "adjust", component: Adjust, props: { lang: String } },
  { path: '/intro/:lang', name: "intro", component: Intro, props: { lang: String } },
  { path: '/steps/:lang', name: "steps", component: Steps, props: { lang: String } },
  { path: '/headset/:lang', name: "headset", component: Headset, props: { lang: String } },
  { path: '/difficulty/:lang', name: "difficulty", component: Difficulty, props: { lang: String } },
  { path: '/record/:lang', name: "record", component: Record, props: { lang: String } },
  { path: '/photo/:lang', name: "photo", component: Photo, props: { lang: String } },
  { path: '/preview/:lang', name: "preview", component: Preview, props: { lang: String } },
  { path: '/selection/:lang', name: "selection", component: Selection, props: { lang: String } },
  { path: '/email/:lang', name: "email", component: Email, props: { lang: String } },
  { path: '/goodbye/:lang', name: "goodbye", component: Goodbye, props: { lang: String } }
]

const router = new VueRouter({
  routes: routes
})

fetch('/settings.json').then(res => res.json()).then(settings => {
  new Vue({
    router,
    components: {},
    vuetify,
    created: function () {
      Object.assign(this.$settings, settings)
    },
    render: h => h(App)
  }).$mount('#app')
})
